<script>
const W_BODY_D =
  'M 4.02,4.46 C -1.27,7.13 -1.31,10.49 3.74,24.63 C 6.26,31.7 17.83,63.95 29.45,96.28 C 41.06,128.62 53.27,162.71 56.58,172.04 C 59.89,181.36 69.55,208.33 78.04,231.96 C 86.53,255.59 100.83,295.53 109.82,320.71 C 118.84,345.97 127.01,367.14 128.05,367.92 C 130.45,369.72 156.47,369.84 162.85,368.07 C 165.34,367.38 168.68,365.89 170.27,364.75 C 172.09,363.47 190.07,332.82 218.29,282.91 C 243.1,239.03 263.74,203.13 264.14,203.13 C 264.54,203.13 284.61,238.11 308.74,280.86 C 332.87,323.61 354.14,360.24 356.02,362.25 C 361.67,368.31 366.44,369.46 384.46,369.09 C 399.61,368.78 400.3,368.66 400.63,366.37 C 400.83,364.998 397.15,357.02 392.03,347.71 C 382.47,330.34 363.2,295.28 318.52,213.98 C 285.18,153.31 288.95,157.53 267.54,156.96 C 251.98,156.54 246.79,157.53 241.6,161.89 C 239.55,163.62 223.16,191.36 198.87,234.22 C 177.2,272.45 159.21,303.74 158.9,303.74 C 158.59,303.74 150.59,281.99 141.13,255.41 C 103.28,149.04 66.78,46.58 59.87,27.31 C 55.36,14.73 51.67,6.21 50.21,4.98 C 48.14,3.26 45.23,3.01 27.33,3.02 C 13.14,3.03 5.96,3.48 4.02,4.46'
const W_LEG_D =
  'M 471.23,0.35 C 469.21,0.64 467.56,1.45 467.56,2.13 C 467.56,2.81 463.45,16.14 458.43,31.74 C 444.55,74.89 421.16,147.77 402.14,207.09 C 397.16,222.63 390.8,242.72 388.01,251.72 L 382.93,268.09 L 397.69,292.08 C 410.48,312.87 412.89,316.17 415.78,316.81 C 417.61,317.21 419.28,317.36 419.49,317.15 C 419.88,316.75 437.64,261.9 441.77,248.35 C 443,244.31 452.92,213.28 463.8,179.38 C 503.18,56.79 518.74,8.05 519.28,5.57 C 519.7,3.59 519.12,2.78 516.61,1.82 C 513.28,0.56 477.69,-0.6 471.23,0.35'

export default {
  name: 'IconIaWMark',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'white',
    },
    // Estado "pensando/trabalhando": o W inteiro pulsa (scale+opacity, tipo
    // respiração) e um brilho atravessa a silhueta em loop — usar só no
    // estado ocioso/streaming; falso por padrão (ex: item de dropdown fica
    // estático).
    animated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bodyD: W_BODY_D,
      legD: W_LEG_D,
    }
  },
  computed: {
    // clipPath/gradient precisam de id único — vários W podem estar na tela
    // ao mesmo tempo (avatares de várias mensagens).
    clipId() {
      return `ia-w-mark-clip-${this._uid}`
    },
    gradientId() {
      return `ia-w-mark-shine-${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 520 370"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ 'ia-w-mark--animated': animated }"
  >
    <path :d="bodyD" :fill="color" />
    <path :d="legD" :fill="color" />

    <template v-if="animated">
      <defs>
        <clipPath :id="clipId">
          <path :d="bodyD" />
          <path :d="legD" />
        </clipPath>
        <linearGradient :id="gradientId" x1="0" y1="0" x2="1" y2="0.15">
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0" />
          <stop offset="50%" stop-color="#FFFFFF" stop-opacity="0.95" />
          <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0" />
        </linearGradient>
      </defs>
      <g :clip-path="`url(#${clipId})`">
        <rect
          class="ia-w-mark-sweep"
          x="-160"
          y="-40"
          width="220"
          height="460"
          :fill="`url(#${gradientId})`"
        />
      </g>
    </template>
  </svg>
</template>

<style lang="sass" scoped>
// "Respiração": o W inteiro pulsa em escala+opacidade — é o sinal principal
// de "trabalhando", legível mesmo em tamanho pequeno (a versão anterior
// dependia só do brilho abaixo, quase imperceptível em 18-28px).
.ia-w-mark--animated
  animation: ia-w-mark-breathe 1.7s ease-in-out infinite
  transform-origin: center
  transform-box: fill-box

@keyframes ia-w-mark-breathe
  0%, 100%
    transform: scale(1)
    opacity: 0.7
  50%
    transform: scale(1.1)
    opacity: 1

// Brilho que atravessa a silhueta do W (perna esquerda -> direita) em loop —
// camada extra sobre o pulso, não é o ícone inteiro que anima aqui.
.ia-w-mark-sweep
  animation: ia-w-mark-sweep-move 3.8s ease-in-out infinite

@keyframes ia-w-mark-sweep-move
  0%
    transform: translateX(0)
  100%
    transform: translateX(680px)

@media (prefers-reduced-motion: reduce)
  .ia-w-mark--animated
    animation: none
  .ia-w-mark-sweep
    animation: none
    opacity: 0
</style>
